export namespace Config {
  export const ReadableEventBeforeMonth = 12 * 5 + 1; // 「60ヶ月より前のデータは表示できません。」
}
